import { uniqueId } from 'lodash';

import { VERIFICATION_TEMPLATE_TYPE_NAMES_SHORT } from 'dashboard/lib/constants/verification';
import {
  VerificationTemplate,
  VerificationTemplateAttributes,
  VerificationTemplateDatabase,
  VerificationTemplateDocument,
  VerificationTemplateGovernmentId,
  VerificationTemplatePhoneNumber,
  VerificationTemplateRelationships,
  VerificationTemplateSelfie,
  VerificationTemplateStatus,
} from 'dashboard/models/verification-template';
import { ApiModel } from 'lib/interfaces/api';

export const generateVerificationTemplateId = () => uniqueId('vtmpl_');

const DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES: VerificationTemplateAttributes = {
  name: 'Verification',
  status: VerificationTemplateStatus.Active,
  'created-at': '2020-02-15T06:31:58.000Z',
  'updated-at': '2020-02-15T09:31:58.000Z',
};

export function createMockVerificationTemplateForType(
  type: VerificationTemplate['type'],
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplate {
  return {
    id: id || generateVerificationTemplateId(),
    type,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: `${VERIFICATION_TEMPLATE_TYPE_NAMES_SHORT[type]} Verification`,
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}

export function createMockVerificationTemplateDatabase(
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplateDatabase {
  return {
    id: id || generateVerificationTemplateId(),
    type: ApiModel.VerificationTemplateDatabase,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: 'Database Verification',
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}

export function createMockVerificationTemplateDocument(
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplateDocument {
  return {
    id: id || generateVerificationTemplateId(),
    type: ApiModel.VerificationTemplateDocument,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: 'Document Verification',
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}

export function createMockVerificationTemplateGovernmentId(
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplateGovernmentId {
  return {
    id: id || generateVerificationTemplateId(),
    type: ApiModel.VerificationTemplateGovernmentId,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: 'GovernmentId Verification',
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}

export function createMockVerificationTemplatePhoneNumber(
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplatePhoneNumber {
  return {
    id: id || generateVerificationTemplateId(),
    type: ApiModel.VerificationTemplatePhoneNumber,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: 'PhoneNumber Verification',
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}

export function createMockVerificationTemplateSelfie(
  attributes?: Partial<VerificationTemplateAttributes>,
  relationships?: Partial<VerificationTemplateRelationships>,
  id?: string,
): VerificationTemplateSelfie {
  return {
    id: id || generateVerificationTemplateId(),
    type: ApiModel.VerificationTemplateSelfie,
    attributes: {
      ...DEFAULT_VERIFICATION_TEMPLATE_ATTRIBUTES,
      name: 'Selfie Verification',
      ...attributes,
    },
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}
